class CrowdfundingPropertyDeliveries {
    crowdfundingPropertyDeliveries;
    deliveries;
    constructor(crowdfundingDeliveries) {
        this.crowdfundingPropertyDeliveries = crowdfundingDeliveries;
        this.deliveries = crowdfundingDeliveries?.crowdfundingDeliveries;
    }
}
export default CrowdfundingPropertyDeliveries;
